import ComponentMap from '../helpers/ComponentMap';
import IconMap from '../helpers/IconMap';

export const clearRoutes = dispatch => dispatch({ type: 'CLEAR_ROUTES' });
const defaultRoutes = dispatch => dispatch({ type: 'ROUTES_FETCH_FULFILLED', payload: { routes: [] } });

export default function getRoutes(location, product) {
    if (!location || !product) return defaultRoutes;
    if (!location.role || !location.role.routes || !Array.isArray(location.role.routes)) return defaultRoutes;

    // if sso login filter out routes with change password
    const isSSOLogin = localStorage.getItem('isSSOLogin') ? JSON.parse(localStorage.getItem('isSSOLogin')) : false;
    let removedChangePasswordRoutes = location.role.routes;

    if (isSSOLogin) {
        removedChangePasswordRoutes = location.role.routes.filter(o => o.path !== '/change-password');
    }

    // location.role.routes array will have routes for all products for the current role
    // we need to filter down to only the routes that match the current product
    // we also want to go ahead and match the string 'component' and 'icon' with their respective map structures
    const routes = removedChangePasswordRoutes
        .filter(r => r.product === product)
        .map(r => ({
            key: r.key,
            path: r.path,
            component: ComponentMap[r.component],
            icon: IconMap[r.icon],
            section: r.section,
            text: r.text,
            order: parseInt(r.order, 10),
        }));

    return dispatch => dispatch({
        type: 'ROUTES_FETCH_FULFILLED',
        payload: { routes }
    });
}


// WEBPACK FOOTER //
// ./src/actions/getRoutes.js